import React, { useState } from "react";
import { Box, Tabs, Tab, Card, CardContent } from "@mui/material";
import ArticlesManagementSubTab from "./SubTabs/ArticlesManagementSubTab";
import ArticlesExportSubTab from "./SubTabs/ArticlesExportSubTab.jsx";

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`credentials-tabpanel-${index}`}
    aria-labelledby={`credentials-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
  </div>
);

const ArticlesManagementTab = () => {
  const [articlesSubTab, setArticlesSubTab] = useState(0);

  const handleArticlesSubTabChange = (event, newValue) => {
    setArticlesSubTab(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Card>
        <CardContent>
          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
            <Tabs
              value={articlesSubTab}
              onChange={handleArticlesSubTabChange}
              aria-label="articles tabs"
            >
              <Tab label="Articles Management" />
              <Tab label="Articles Export" />
            </Tabs>
          </Box>

          {/* Articles Management Tab */}
          <TabPanel value={articlesSubTab} index={0}>
            <ArticlesManagementSubTab />
          </TabPanel>

          {/* Articles Export Tab */}
          <TabPanel value={articlesSubTab} index={1}>
            <ArticlesExportSubTab />
          </TabPanel>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ArticlesManagementTab;
